import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Breadcrumb,
  Tabs,
  Tab
} from 'react-bootstrap'
import { Link } from 'react-router'


import Completed from './tasks/partnercompleted'
import Pending from './tasks/partnerpending'


@observer(['tasks'])
export default class PartnerTasks extends Component {
  constructor(props) {
    super(props)

    this.props.tasks.loadTaskStates()
    this.props.tasks.loadAllTaskPriorities()
  }

  render() {

    let defaultTab = 1

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Partner Tasks</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Tabs defaultActiveKey={ defaultTab } id="site-options-tabs">
            <Tab eventKey={ 1 } title="Pending">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              <Pending />
              </div>
            </Tab>
            { /*
            <Tab eventKey={ 2 } title="Postponed">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              <Postponed />
              </div>
            </Tab>
            */ }
            <Tab eventKey={ 2 } title="Completed">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              <Completed />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partnertasks.js